import React, { Component } from 'react';

const style = {
  maxWidth: '80px',
  width: '100%'
};

export default class Header extends Component {
  render() {
    return (
      <header>
        <div className="container">
          <div className="row">
            <div className="col-xs-4">
              <img
                style={{ ...style }}
                src="img/LogoFoko_Blanco-13.png"
                alt="logo"
              />
            </div>
            <div
              className="col-xs-8"
              style={{
                textAlign: 'right',
                paddingTop: '12px',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '16px'
              }}
            >
              <span>(809) 331-3737</span> | <span>info@fokoconsulting.com</span>
            </div>
          </div>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/survey/Header.jsx